import React, { Component } from 'react';
import './style.sass';
import parse from 'html-react-parser';

import CrewItem from '../crew-item';
import CommonSmallTitle from '../../../common-components/common-small-title';
import CommonSmallText from '../../../common-components/common-small-text';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

class CrewContainer extends Component {
    state = {
        isMobile: false,
        height: 0,
    };

    render() {
        const {
            container: { crewTitle, crewSubtitle, crewList },
        } = this.props;

        return (
            <div>
                {crewTitle ? (
                    <ScrollAnimation
                        animateIn="fadeIn"
                        delay={100}
                        offset={0}
                        animateOnce={true}
                        duration={1}
                    >
                        <CommonSmallTitle className="crew__subtitle">
                            {parse(crewTitle)}
                        </CommonSmallTitle>
                    </ScrollAnimation>
                ) : null}
                {crewSubtitle ? (
                    <ScrollAnimation
                        animateIn="fadeIn"
                        delay={100}
                        offset={0}
                        animateOnce={true}
                        duration={1}
                    >
                        <CommonSmallText className="crew__sub-subtitle">
                            {parse(crewSubtitle)}
                        </CommonSmallText>
                    </ScrollAnimation>
                ) : null}
                <div className="crew__list-container">
                    {crewList.map(
                        ({ crewItemImg, crewItemTitle, crewItemSubtitle, color }, index) => {
                            return (
                                <CrewItem
                                    key={index}
                                    color={color}
                                    crewItemImg={crewItemImg}
                                    crewItemTitle={crewItemTitle}
                                    crewItemSubtitle={crewItemSubtitle}
                                />
                            );
                        }
                    )}
                </div>
            </div>
        );
    }
}

export default CrewContainer;
